import { createContext } from "react";

export const CreateClientContext = createContext({
  isLoading: false,
  formData: {
    client_name: "",
    referant_email: "",
    referant_password: "",
  },
  onValueChange: (slug: string) => function (value: any) {},
  submitForm: function () {},
  errorState: {
    client_name: { state: false, msg: "" },
    referant_email: { state: false, msg: "" },
    referant_password: { state: false, msg: "" },
  },
});
